export function setShowNavBar(showSidebar) {
    return {
        type: 'SET_SHOWSIDEBAR',
        payload: { showSidebar: showSidebar },
    };
}
